module.exports = __webpack_public_path__ + "img/6d.633034c0.png";